'use strict';

var Sugar = require('sugar-core');

Sugar.Date.defineInstance({

  'getUTCWeekday': function(date) {
    return date.getUTCDay();
  }

});

module.exports = Sugar.Date.getUTCWeekday;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/getUTCWeekday.js
// module id = 502
// module chunks = 0